const ResourceLabel = ({ name, serviceCode }) => (
    <div>
        <div>{name || ''}</div>
        <div className='text-muted' style={{ fontSize: '10px', lineHeight: 1.2 }}>{serviceCode || ''}</div>
    </div>
);

export default ResourceLabel;
